import React from 'react';
import {Chip, Paper, Stack, Typography} from "@mui/material"
import {DemoDatasetJson} from "../../../api/json/DemoDatasetJson"
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined"
import ProjectTypeIcon from "../ProjectTypeIcon"
import {resolveNameForProjectType} from "../../../api/enum/ProjectType"

interface DatasetCardProps {
    dataset: DemoDatasetJson
    onClick: (dataset: DemoDatasetJson) => void
}

function DemoDatasetCard({dataset, onClick}: DatasetCardProps) {
    return (
        <Paper
            onClick={() => onClick(dataset)}
            sx={{
                p: 3,
                borderRadius: '8px',
                border: '1px solid #ececf1',
                bgcolor: '#fff',
                cursor: 'pointer',
                transition: 'box-shadow 150ms ease, border-color 150ms ease',
                '&:hover': {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                    borderColor: '#d0d0d8',
                },
            }}
            elevation={0}
        >
            <Stack spacing={2}>
                <Stack spacing={0.5}>
                    <Typography sx={{fontWeight: 600, fontSize: '0.95rem'}}>
                        {dataset.name}
                    </Typography>
                    <Typography sx={{
                        fontSize: '0.8rem',
                        color: '#888',
                        lineHeight: 1.4,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                    }}>
                        {dataset.description}
                    </Typography>
                </Stack>

                <Stack direction="row" spacing={1}>
                    <Chip
                        icon={<ProjectTypeIcon type={dataset.type} sx={{fontSize: 14}}/>}
                        label={resolveNameForProjectType(dataset.type)}
                        size="small"
                        variant="outlined"
                        sx={{fontSize: '0.75rem', height: 26, px: 0.5}}
                    />
                    <Chip
                        icon={<TableChartOutlinedIcon sx={{fontSize: 14}}/>}
                        label={`${dataset.numberOfRecords.toLocaleString()} rows`}
                        size="small"
                        variant="outlined"
                        sx={{fontSize: '0.75rem', height: 26, px: 0.5}}
                    />
                </Stack>
            </Stack>
        </Paper>
    );
}

export default DemoDatasetCard;
